import cx from 'clsx';
import * as React from 'react';

import { QuicksilverTileOutfitType } from '@/components/game-tile/types';
import { useWindowSize } from '@/hooks/useWindowSize';
import { Table } from '@/types/gameTypes';

import styles from './LiveTableLayer.module.scss';
import LiveTableLayerInfo from './LiveTableLayerInfo';
import LiveTablePlayers from './LiveTablePlayers';
import LiveTableResults from './LiveTableResults';

const GT_LT_LAYER_TEST_ATTR_TILE = 'gt-live-table-layer';

interface LiveTableLayerProps {
  table: Table;
  fullPlayersText?: string;
  outfit: QuicksilverTileOutfitType;
}

const LiveTableLayer = ({
  table,
  fullPlayersText = 'Bet behind',
  outfit,
}: LiveTableLayerProps) => {
  const seatsInfoAvailable = table.seats && outfit === 'banner';
  const resultsInfoAvailable =
    table.results && outfit !== 'medium' && !seatsInfoAvailable;
  const [tileWidth, setTileWidth] = React.useState<number>(0);
  const { width } = useWindowSize();
  const div = React.useCallback(
    (node: HTMLElement | null) => {
      if (node !== null) {
        setTileWidth(node.getBoundingClientRect().width);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [width]
  );

  return (
    <div
      ref={div}
      className={cx(styles.container)}
      data-testid={GT_LT_LAYER_TEST_ATTR_TILE}
    >
      {resultsInfoAvailable && !seatsInfoAvailable && (
        <LiveTableResults
          results={table.results!}
          outfit={outfit}
          tileWidth={tileWidth}
        />
      )}
      {seatsInfoAvailable && (
        <LiveTablePlayers
          seats={table.seats!}
          players={table.players}
          tileWidth={tileWidth}
          fullPlayersText={fullPlayersText}
        />
      )}
      <LiveTableLayerInfo
        outfit={outfit}
        stake={table.stake}
        players={table.players}
        seats={table.seats}
        locale={table.locale}
        currencyCode={table.currencyCode}
      />
    </div>
  );
};

export default LiveTableLayer;
